import React, { useRef, useState } from "react";
import { Link } from 'react-router-dom';
import Search from "../pageInside/search";
import DrawerToggleButton from '../../components/SIdeDrawer/DrawerToggleButton';
import { isAuthenticated, SetElakayLang, getElakayLang } from "../auth";
import logoCart from './icon/cart.svg';
import logoElakay from './icon/logoelakayDiamant-256.png';
import { MdLanguage } from "react-icons/md";
import { GrUpdate } from "react-icons/gr";
import { FaChartLine, FaStore, FaTags } from "react-icons/fa";
import { GrAscend } from "react-icons/gr";
import { laguangeElakay, elakayAutoText } from "../pageInside/dataElakay";
import { canAccessMyShop, isProviderOnlyWorkspace } from "../pageInside/Rolle";
import RoleSwitchDropdown from "../../components/RoleSwitch/RoleSwitchDropdown";
import { useHeaderHeightVar } from "./useHeaderHeightVar";
import { useSmartStickyHeader } from "./useSmartStickyHeader";
import './SmartStickyHeader.css';
import { buildMobilePrimaryNavigation } from "./primaryNavigation";
import './elakay_index.css';
import './HeaderFooterCollections.css';
import { collectionAttribute, useHeaderFooterCollection } from './headerFooterCollections';
import HeaderFooterPreviewBanner from './HeaderFooterPreviewBanner';

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["header"]?.[key] || fallback;

// ─────────────────────────────────────────────────────────────────────────────
// Valeurs CSS d'origine — identiques aux couleurs hardcodées dans elakay_index.css.
// Utilisées comme fallback quand colorsEnabled est false (aucune variable injectée)
// ET comme valeur initiale des pickers quand colorsEnabled passe à true.
// Ces valeurs sont AUSSI exportées pour que AnimationSettings.jsx puisse les
// importer au lieu de les dupliquer dans COLOR_DEFAULTS.header.
// ─────────────────────────────────────────────────────────────────────────────


export const HEADER_COLOR_DEFAULTS = {
    // Fond — .header { background: linear-gradient(135deg, #004b63 0%, #007399 30%, #00a4d8 60%, #4facfe 100%) }
    backgroundColor:          '#007399',
    backgroundColorSecondary: '#004b63',
    // .header::before { background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), rgba(255,255,255,0.3), ...) }
    shineColor:               'rgba(255,255,255,0.3)',

    // Texte & Liens — .header { color: #ffffff } / .nav-link { color: white }
    textColor:                '#ffffff',
    linkColor:                '#ffffff',
    linkHoverColor:           '#e0f4fa',
    // .nav-link::after { background: linear-gradient(90deg, #4facfe, ...) }
    accentColor:              '#4facfe',

    // Recherche — .elakay_search { background: linear-gradient(120deg, #e5f3ff ...) }
    searchBackgroundColor:    'rgba(255,255,255,0.15)',
    // .elakay_input_search { color: #0f172a }
    searchTextColor:          '#0f172a',

    // Décoratif — #count gradient : #f97373 → #ef4444 → #dc2626
    cartBadgeColor:           '#ef4444',
    // @keyframes headerBreath : 0 4px 25px rgba(0,0,0,0.4)
    shadowColor:              'rgba(0,0,0,0.4)',
    // inset 0 -1px 0 rgba(255,255,255,0.1)
    borderColor:              'rgba(255,255,255,0.1)',
};

// ─────────────────────────────────────────────────────────────────────────────
const isMobileDevice = (device) => device === "iPhone" || device === "Android Phone";
// ─────────────────────────────────────────────────────────────────────────────

const Header = (props) => {
    const headerRef = useRef(null);
    const [mobileSearchExpanded, setMobileSearchExpanded] = useState(false);
    useHeaderHeightVar(headerRef);

    const {
        infoSource,
        drawerClickHander,
        setActiveHeader,
        outOffPage = true,

        // ── Animation controls ────────────────────────────────────────────
        enableHeaderAnimations  = true,
        enableLogoAnimation     = true,
        enableSearchAnimation   = true,
        enableMenuAnimation     = true,
        enableNavigationItemAnimations = true,
        enableNavigationIconAnimations = true,
        enableLanguageAnimation = true,
        enableUserAnimation     = true,
        enableCartAnimation     = true,
        enableShineEffect       = true,
        enableBreathEffect      = true,
        enableHoverAnimations   = true,

        // ── Switch couleurs ───────────────────────────────────────────────
        // false  → aucune variable CSS injectée → CSS natif appliqué
        // true   → les props couleur ci-dessous sont injectées via style={}
        colorsEnabled = false,

        // ── Couleurs Fond ─────────────────────────────────────────────────
        backgroundColor          = HEADER_COLOR_DEFAULTS.backgroundColor,
        backgroundColorSecondary = HEADER_COLOR_DEFAULTS.backgroundColorSecondary,
        shineColor               = HEADER_COLOR_DEFAULTS.shineColor,

        // ── Couleurs Texte & Liens ────────────────────────────────────────
        textColor      = HEADER_COLOR_DEFAULTS.textColor,
        linkColor      = HEADER_COLOR_DEFAULTS.linkColor,
        linkHoverColor = HEADER_COLOR_DEFAULTS.linkHoverColor,
        accentColor    = HEADER_COLOR_DEFAULTS.accentColor,

        // ── Couleurs Recherche ────────────────────────────────────────────
        searchBackgroundColor = HEADER_COLOR_DEFAULTS.searchBackgroundColor,
        searchTextColor       = HEADER_COLOR_DEFAULTS.searchTextColor,

        // ── Couleurs Décoratif & Effets ───────────────────────────────────
        cartBadgeColor = HEADER_COLOR_DEFAULTS.cartBadgeColor,
        shadowColor    = HEADER_COLOR_DEFAULTS.shadowColor,
        borderColor    = HEADER_COLOR_DEFAULTS.borderColor,

        // ── Legacy (rétro-compatibilité) ──────────────────────────────────
        headerGradientStart = backgroundColor,
        headerGradientEnd   = backgroundColorSecondary,
        pageTopRef = null,
        // Smart Sticky Header (AnimationSettings → header.stickyHeader).
        stickyHeader = null,
    } = props;
  __setElakayInfoSource(infoSource);

    // ─────────────────────────────────────────────────────────────────────
    // Variables CSS injectées sur <header style={...}>
    //
    //   colorsEnabled === false  →  style={{}}
    //     • Aucune variable --hdr-xxx définie sur l'élément
    //     • elakay_index.css utilise ses couleurs hardcodées
    //     • Comportement identique à AVANT l'ajout du système de couleurs
    //
    //   colorsEnabled === true   →  style={ toutes les --hdr-xxx }
    //     • Les variables CSS surchargent les valeurs hardcodées
    //     • Chaque var(--hdr-xxx) dans le CSS reçoit la couleur du picker
    // ─────────────────────────────────────────────────────────────────────
    const headerColorVars = colorsEnabled
        ? {
            '--hdr-bg'               : backgroundColor,
            '--hdr-bg-secondary'     : backgroundColorSecondary,
            '--hdr-gradient'         : `linear-gradient(135deg, ${backgroundColor} 0%, ${backgroundColorSecondary} 30%, ${backgroundColor} 100%)`,
            '--hdr-text'             : textColor,
            '--hdr-link'             : linkColor,
            '--hdr-link-hover'       : linkHoverColor,
            '--hdr-search-bg'        : searchBackgroundColor,
            '--hdr-search-text'      : searchTextColor,
            '--hdr-accent'           : accentColor,
            '--hdr-badge'            : cartBadgeColor,
            '--hdr-shadow'           : shadowColor,
            '--hdr-border'           : borderColor,
            '--hdr-shine'            : shineColor,
            // legacy aliases
            '--header-gradient-start': headerGradientStart,
            '--header-gradient-end'  : headerGradientEnd,
          }
        : {};
    // ─────────────────────────────────────────────────────────────────────
    // Couleurs inline sur les éléments enfants.
    // Même logique : transmises seulement si colorsEnabled.
    // Quand colorsEnabled est false, on passe undefined → React n'ajoute
    // aucun style inline, le CSS natif s'applique.
    // ─────────────────────────────────────────────────────────────────────
    const inlineText   = colorsEnabled ? { color: textColor }   : undefined;
    const inlineLink   = colorsEnabled ? { color: linkColor }   : undefined;
    const inlineBadge  = colorsEnabled ? { background: cartBadgeColor } : undefined;
    const inlineAccent = colorsEnabled ? { color: textColor, borderColor: accentColor } : undefined;

    // ─────────────────────────────────────────────────────────────────────

    const { id, obj } = getElakayLang();

    const allLanguage = [
        { "code": "en", "name": __elakayText("t005", "English"),                "nativeName": "English"              },
        { "code": "es", "name": __elakayText("t003", "Spanish; Castilian"),     "nativeName": "español, castellano"  },
        { "code": "ht", "name": __elakayText("t004", "Haitian; Haitian Creole"),"nativeName": "Kreyòl ayisyen"       },
        { "code": "fr", "name": __elakayText("t006", "French"),                 "nativeName": "français, langue française" },
        { "code": "pt", "name": __elakayText("t007", "Portuguese"),             "nativeName": "Português"            },
    ];

  const handleChange = name => event => {
    const value = event.target.value;

    const selectedLang = allLanguage.find(l => l.code === value);

    if (selectedLang) {
        SetElakayLang(selectedLang);
    }
};

    // ── Logo ─────────────────────────────────────────────────────────────
    const logo = () => (
        <div
    
            id="logo_mlakay"
            className={`logo-container ${!enableLogoAnimation ? 'no-animation' : ''}`}
        >
            <Link to="/" className="logo-link">
                <h1 className="logo-text">
                    <img
                        className="img-responsive logo-img"
                        src={logoElakay}
                        width="50"
                        alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).header.t001}
                    />
                    <span className="logo-name" style={inlineText}>{__elakayText("t008", "elakay")}</span>
                </h1>
            </Link>
        </div>
    );

    // ── Barre de recherche ────────────────────────────────────────────────
    const SearchElakay = () => (
        <div
            className={`formElakaySearch ${!enableSearchAnimation ? 'no-animation' : ''}`}
            style={colorsEnabled
                ? { '--search-bg': searchBackgroundColor, '--search-text': searchTextColor }
                : undefined
            }
        >
            <Search
                infoSource={infoSource}
                collapseOnMobile
                onExpandedChange={setMobileSearchExpanded}
            />
        </div>
    );

    // ── Formatage nom ─────────────────────────────────────────────────────
    const capitalizeFirst = (s = "") => {
        const str = String(s).trim();
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    const lastNameInitial = (lastname = "") => {
        const str = String(lastname).trim();
        if (!str) return "";
        return str.split(/\s+/)[0].charAt(0).toUpperCase() + ".";
    };

    const formatShortName = (firstname = "", lastname = "") =>
        [capitalizeFirst(firstname), lastNameInitial(lastname)].filter(Boolean).join(" ");

    // ── Menu + nav + langue + user + panier ───────────────────────────────
    const mobileItems = buildMobilePrimaryNavigation(infoSource);
    const mobileNavIcon = { deal: FaTags, step: GrAscend, center: FaChartLine, shop: FaStore };

    const menuHeader = () => (
        <div className="menu-header-wrapper">

            {/* DrawerToggleButton */}
            <div className={`elakay_departement ${!enableMenuAnimation || !enableNavigationIconAnimations ? 'no-animation' : ''}`}>
                <DrawerToggleButton click={drawerClickHander} v />
            </div>

            {!mobileSearchExpanded && (
                <nav className="header-mobile-primary-nav" aria-label={elakayAutoText("h_mobile_primary_navigation", "Navigation principale mobile")}>
                    {mobileItems.map((item) => {
                        const Icon = mobileNavIcon[item.icon] || FaStore;
                        return (
                            <Link key={item.key} to={item.route} className="header-mobile-primary-link" style={inlineLink}>
                                <Icon className="header-mobile-primary-icon" aria-hidden="true" />
                                <span>{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>
            )}

            {/* Liens nav */}
            <div className={`elakay_liste_header ${!enableMenuAnimation || !enableNavigationItemAnimations ? 'no-animation' : ''} ${!enableNavigationIconAnimations ? 'no-icon-animation' : ''}`}>
                <ul className="largenav pull-right1">
                    {!outOffPage && (
                        <li onClick={() => setActiveHeader(2)} className="nav-item">
                            <GrUpdate className="nav-icon" style={inlineText} />
                        </li>
                    )}

                    <li className="nav-item">
                        <Link
                            className="me-l-2 nav-link"
                            to="/deal-today"
                            style={inlineLink}
                        >
                            {infoSource.laguangeElakay('headNenu', infoSource.languageAPI).todayDeal}
                        </Link>
                    </li>

                    {canAccessMyShop(infoSource) && isProviderOnlyWorkspace(infoSource) ? (
                        // Effective Provider: Provider Center replaces the Seller Sell Center / My Shop links.
                        <>
                            <li className="nav-item">
                                <Link className="me-l-3 nav-link" to="/provider" style={inlineLink}>
                                    {elakayAutoText("h_pvc_title", "Provider Center")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="me-l-3 nav-link" to="/provider/my-shop" style={inlineLink}>
                                    {infoSource.laguangeElakay('headNenu', infoSource.languageAPI).myShop}
                                </Link>
                            </li>
                        </>
                    ) : canAccessMyShop(infoSource) ? (
                        <>
                            <li className="nav-item">
                                <Link
                                    className="me-l-3 nav-link"
                                    to="/myshop?tab=sell-center"
                                    style={inlineLink}
                                >
                                    {elakayAutoText("h_mobile_sell_center", "Sell Center")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="me-l-3 nav-link"
                                    to="/myshop"
                                    style={inlineLink}
                                >
                                    {infoSource.laguangeElakay('headNenu', infoSource.languageAPI).myShop}
                                </Link>
                            </li>
                        </>
                    ) : (
                        <li className="nav-item">
                            <Link
                                to="/your-step"
                                className="nav-link"
                                style={inlineLink}
                            >
                                {infoSource.laguangeElakay('menuList', infoSource.languageAPI).yourStep}
                            </Link>
                        </li>
                    )}

                    <li className="me-l-5 nav-item">
                        <Link
                            id="help_contact"
                            to="/help-contact"
                            className="nav-link"
                            style={inlineLink}
                        >
                            {infoSource.laguangeElakay('headNenu', infoSource.languageAPI).helpContact}
                        </Link>
                    </li>

                    <li className="me-l-3 nav-item">
                        <RoleSwitchDropdown infoSource={infoSource} triggerClassName="nav-link" triggerStyle={inlineLink} />
                    </li>
                </ul>
            </div>

        {/* Sélecteur de langue */}
<div className={`Langage_elakay language-selector ${!enableLanguageAnimation ? 'no-animation' : ''}`}>
    <MdLanguage className="language-icon" style={inlineText} />

    <select
        value={obj?.code || 'en'}
        className="language-select"
        style={inlineAccent}
        onChange={handleChange('elakayLanguage')}
    >
        {allLanguage?.map((l, i) => (
            <option key={i} value={l.code}>
                {l.code}
            </option>
        ))}
    </select>
</div>

            {/* Compte utilisateur */}
            <div className={`user_elakay user-account ${!enableUserAnimation ? 'no-animation' : ''}`}>
                {!isAuthenticated() ? (
                    <Link to="/signin" className="user-link" style={inlineLink}>
                        <span className="user-welcome">
                            {infoSource.laguangeElakay('Button', infoSource.languageAPI).signin}
                        </span>
                    </Link>
                ) : (
                    <Link to="/profile" className="user-link" style={inlineLink}>
                        <span className="user-greeting" style={inlineText}>
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).welcomeBack}
                        </span>
                        <br />
                        <strong className="user-name" style={inlineText}>
                            {formatShortName(
                                infoSource?.userInfo?.firstname,
                                infoSource?.userInfo?.lastname
                            )}
                        </strong>
                    </Link>
                )}
            </div>

            {/* Cart : conserve son icône SVG blanche d'origine. */}
            <div className="header-floating-actions">
                <div className={`mlakay_shoppingcart ${!enableCartAnimation ? 'no-animation' : ''}`}>
                    <div className="mlakay_shoppingcart_name">
                        <Link to="/cart" className="cart-link">
                            <span className="cart-icon-wrapper">
                                <img className="cart-icon" src={logoCart} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).header.t002} />
                                <sup className="cart-badge" style={inlineBadge}>
                                    <span id="count" className="cart-count cart-count-badge">
                                        {infoSource.getCartItems?.length || 0}
                                    </span>
                                </sup>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>

        </div>
    );

    // ─────────────────────────────────────────────────────────────────────
    // Header & Footer Collections: no attribute at all for the ORIGINAL design.
    const hfCollection = useHeaderFooterCollection(infoSource);
    // An open mobile search keeps the full header (never collapsed under the user).
    const sticky = useSmartStickyHeader(headerRef, stickyHeader, { locked: mobileSearchExpanded });
    return (
        <header
            ref={headerRef}
            className={[
                'header modern-header',
                !enableHeaderAnimations ? 'no-header-animations' : '',
                !enableShineEffect      ? 'no-shine'             : '',
                !enableBreathEffect     ? 'no-breath'            : '',
                !enableHoverAnimations  ? 'no-hover'             : '',
                sticky.className,
            ].filter(Boolean).join(' ')}
            style={sticky.style ? { ...headerColorVars, ...sticky.style } : headerColorVars}
            data-sticky-state={sticky.active ? sticky.state : undefined}
            data-hf-collection={collectionAttribute(hfCollection)}
        >
            <div ref={pageTopRef} className="header-overlay" />
            <div className="navbar">
                {logo()}
                {SearchElakay()}
                {menuHeader()}
            </div>
            <HeaderFooterPreviewBanner infoSource={infoSource} />
        </header>
    );
};

export default Header;
